import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
// Core components
import MenuButton from 'components/core/MenuButton';
// Custom
import { refreshList } from 'actions';
import { menuItemsShape } from 'constants/PropTypesShapes';
import { RefreshTextButton } from 'components/buttons/TextButtons';
import ListTemplate from './ListTemplate';

const SubListTemplate = ({
  title, displayRefresh, actionButtons, extraActionButtons, menuItems, additionalContent, handleRefreshList, ...otherProps
}) => {
  // All buttons
  const buttons = actionButtons || [];
  if (displayRefresh) {
    buttons.push(<RefreshTextButton key="refresh" primary onClick={handleRefreshList} />);
  }

  return (
    <React.Fragment>
      {title && (
        <div className="box box-default m-0">
          <div className="box-header c-list-header box-title py-2 d-flex align-items-center">
            <div style={{ flex: '1 1 auto' }} className="d-flex align-items-center">
              {title}
            </div>
            <div style={{ flex: '0 0 auto' }} className="d-flex align-items-end align-items-md-center flex-column flex-md-row left-spaced-buttons">
              { buttons }
              {!_isEmpty(menuItems) && (
                <div className="c-list-header-menu">
                  <MenuButton items={menuItems} />
                </div>
              )}
              {!_isEmpty(extraActionButtons) && (
                <div className="c-list-header-extra d-flex align-items-end align-items-md-center flex-column flex-md-row">
                  { extraActionButtons }
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {additionalContent}
      <div className="pt-4 px-0 w-100">
        <ListTemplate {...otherProps} />
      </div>
    </React.Fragment>
  );
};

SubListTemplate.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  displayRefresh: PropTypes.bool,
  actionButtons: PropTypes.arrayOf(PropTypes.element),
  extraActionButtons: PropTypes.arrayOf(PropTypes.element),
  menuItems: menuItemsShape,
  additionalContent: PropTypes.element,
  handleRefreshList: PropTypes.func.isRequired,
};

SubListTemplate.defaultProps = {
  title: null,
  displayRefresh: false,
  actionButtons: null,
  extraActionButtons: null,
  menuItems: null,
  additionalContent: null,
};

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
});

module.exports = connect(
  null,
  mapDispatchToProps,
)(SubListTemplate);



// WEBPACK FOOTER //
// ./components/templates/SubListTemplate.js